// ─── SINGLE SOURCE OF TRUTH FOR ALL SEO ──────────────────────────────────────
// Every meta tag, JSON-LD schema, robots directive, and sitemap entry is
// derived from this file. Edit here — nowhere else.
// TODO: update portfolioURL once the site is deployed.
// ─────────────────────────────────────────────────────────────────────────────

export const SEO = {
  // ── Identity ────────────────────────────────────────────────────────────────
  name:           'Pujari Keerthika',
  alternateNames: ['Keerthika Pujari', 'Keerthika', 'Ms. Pujari Keerthika'],
  givenName:      'Keerthika',
  familyName:     'Pujari',
  displayName:    'Ms. Pujari Keerthika',
  jobTitle:       'AI & Machine Learning Researcher',
  bio:
    'Undergraduate AI researcher at SRM University and IIT Madras (BS in Data Science and Applications), ' +
    'with published work in 3D scene reconstruction and cross-subject EMG gesture recognition. ' +
    'Research interests span computer vision, NLP, medical imaging, and ML for scientific applications.',

  // ── Contact & Location ──────────────────────────────────────────────────────
  email:        'keerthikapujari25@gmail.com',
  city:         'Chennai',
  state:        'Tamil Nadu',
  country:      'IN',
  countryName:  'India',

  // ── Web presence ────────────────────────────────────────────────────────────
  portfolioURL:  'https://keerthika.me',
  profilePhoto:  'https://keerthika.me/Portfolio.jpg',
  ogImage:       'https://keerthika.me/og-image.png',
  themeColor:    '#0a0814',
  twitterHandle: '@keekee2204',

  sameAs: [
    'https://github.com/keethu12345',
    'https://www.linkedin.com/in/keerthika-pujari-404bb424b/',
    'https://twitter.com/keekee2204',
    'https://linktr.ee/keerthika_pujari',
  ],

  // ── Skills (drives knowsAbout in schema) ────────────────────────────────────
  skills: [
    'Python', 'PyTorch', 'TensorFlow', 'Machine Learning', 'Deep Learning',
    'Computer Vision', 'Natural Language Processing', '3D Scene Reconstruction',
    'Neural Radiance Fields (NeRF)', 'Vision Transformers', 'EMG Signal Processing',
    'Medical Imaging', 'Data Science', 'Data Analytics', 'Predictive Modeling',
    'Contrastive Learning', 'Kubernetes', 'NLP for Intent-Based Networking',
    'scikit-learn', 'NumPy', 'Pandas', 'Matplotlib',
  ],

  // ── Education (drives alumniOf in schema) ───────────────────────────────────
  education: [
    {
      institution: 'SRM Institute of Science and Technology',
      degree:      'Bachelor of Technology',
      field:       'Computer Science and Engineering',
      location:    'Chennai, Tamil Nadu, India',
      url:         'https://www.srmist.edu.in',
    },
    {
      institution: 'Indian Institute of Technology Madras',
      degree:      'Bachelor of Science',
      field:       'Data Science and Applications',
      location:    'Chennai, Tamil Nadu, India',
      url:         'https://study.iitm.ac.in',
    },
  ],

  // ── Publications (drives ScholarlyArticle schema) ────────────────────────────
  publications: [
    {
      id:          'pub-siscon-2025',
      slug:        'siscon-2025',
      conference:  '2025 1st International Conference on Smart and Intelligent Systems (SISCON)',
      keywords:    ['Neural Radiance Fields', 'NeRF', 'Vision Transformers', 'SegFormer', '3D Scene Reconstruction', 'Computer Vision'],
      title:
        'A NeRF-Transformer Hybrid Framework for High-Quality 3D Scene Reconstruction ' +
        'and Contextual Interpretation',
      description:
        'Hybrid pipeline combining Neural Radiance Fields with Vision Transformers (SegFormer) ' +
        'for high-quality 3D scene reconstruction and contextual semantic interpretation. ' +
        'Published at SISCON 2025 (IEEE).',
      authors:       ['Pujari Keerthika', 'Padmalakshmi S', 'Moksha R', 'M.S Minu'],
      publisher:     'IEEE',
      datePublished: '2025',
      doi:           '10.1109/SISCON66686.2025',
      publisherLink: 'https://ieeexplore.ieee.org/document/11409011',
    },
    {
      id:          'pub-icret-2026',
      slug:        'icret-2026',
      conference:  '17th International Conference on Recent Engineering and Technology (ICRET 2026)',
      keywords:    ['Surface Electromyography', 'sEMG', 'Hand Gesture Recognition', 'CNN-Transformer', 'Supervised Contrastive Learning'],
      title:
        'Cross-Subject Robust EMG-Based Hand Gesture Recognition Using a Hybrid CNN-Transformer',
      description:
        'Multi-scale CNN + Transformer architecture with supervised contrastive learning for ' +
        'robust cross-subject hand gesture recognition from sEMG signals. 92.4% accuracy across ' +
        '36 subjects. Accepted at the 17th International Conference on Recent Engineering and ' +
        'Technology (ICRET 2026).',
      authors:       ['Padmalakshmi S', 'S. Sridevi', 'Pujari Keerthika', 'Moksha R'],
      publisher:     null,
      datePublished: null,
      doi:           null,
      publisherLink: null,
    },
  ],

  // ── Projects (drives CreativeWork schema) ────────────────────────────────────
  projects: [
    {
      name:        'Predictive Modelling in Lung Cancer',
      description:
        'Deep learning applied to medical imaging for early-stage lung cancer detection, ' +
        'combining predictive analytics with AI-driven prognosis for improved patient outcomes.',
      url:  'https://github.com/keethu12345/Predictive_modelling_In_Lung_Cancer',
      type: 'SoftwareSourceCode' as const,
    },
    {
      name:        'PFAS Source Tracing Using Machine Learning',
      description:
        'Machine learning classification of PFAS contamination sources in environmental datasets, ' +
        'with fingerprint analysis across fish tissue samples.',
      url:  'https://github.com/keethu12345/Tracing_PFAS_Source_Using_ML',
      type: 'SoftwareSourceCode' as const,
    },
    {
      name:        'NLP for Intent-Based Networking (Kubernetes)',
      description:
        'Fine-tuned large language models on Kubernetes documentation to automate intent-based ' +
        'network configuration, enabling AI-driven management with minimal human intervention.',
      url:  'https://github.com/keethu12345/Kubernetes_ML-Model',
      type: 'SoftwareSourceCode' as const,
    },
  ],

  // ── Per-page metadata ────────────────────────────────────────────────────────
  // The /about, /publications, /projects and /contact routes are static
  // prerendered pages under public/ — their metadata lives in those HTML files.
  pages: {
    home: {
      title:
        'Pujari Keerthika | AI & Machine Learning Researcher',
      description:
        'Pujari Keerthika — AI & ML researcher at SRM & IIT Madras. Peer-reviewed work in NeRF 3D ' +
        'reconstruction and EMG gesture recognition. Open to PhD roles.',
      canonical: 'https://keerthika.me/',
    },
  },

  // Bumped whenever page content changes; used for dateModified + sitemap lastmod
  lastUpdated: '2026-11-04',
} as const

export type SeoConfig = typeof SEO
